// maestroo docs on javascript events exposed by the theme
// https://support.maestrooo.com/article/764-javascript-events-exposed-by-the-theme


var sidebar_country_dropdown = document.querySelector('#sidebar-menu .county_wrapper .flag-icon');
if(sidebar_country_dropdown) {
    sidebar_country_dropdown.addEventListener("click", function(e) {
      console.log('click');
      var parent = this.closest('.county_wrapper');
      var sidebarElem = this.closest('#sidebar-menu');
      sidebarElem.classList.add('open_contry_select');
      parent.classList.add('active');
    });

    var countries_links_close = document.querySelector('#sidebar-menu .county_wrapper .countries-links_close');
    countries_links_close.addEventListener("click", function(e) {
      var parent = this.closest('.county_wrapper');
      var sidebarElem = this.closest('#sidebar-menu');
      sidebarElem.classList.remove('open_contry_select');
      parent.classList.remove('active');
    });
  }


  //update cart count
  // document.querySelector('.cart-count').textContent = '5'; 

// added to cart
  // document.addEventListener('variant:add', function(event) {
  //   let items = event.detail.items; // Get items added
  //   let cart = event.detail.cart; // The whole cart content after the update
  //   console.log('Item added to cart');
  // });

  // cart line item has changed
  // document.addEventListener('line-item:change', function(event) {
  //   let finalQuantity = event.detail.quantity; // New quantity (may be 0 !)
  //   let cart = event.detail.cart;
  //   console.log('Cart line item has changed');
  // });

// adjust z-index of smile.io popup
  const observer = new MutationObserver(() => {
    const container = document.querySelector('#smile-ui-container, #smile-ui-lite-container');
    if (container) {
      container.style.setProperty('z-index', '5', 'important');
      observer.disconnect(); // stop observing once it's applied
    }
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
// cartixß
// this will add item to cartix cart
//  window.CD_ADDTOCART({
//     id: '39654215221303',
//     quantity: 1
//   }); 

// checks if the cartdrawer script is loaded - useful to wrap logic 
  // window.CD_LOADED() 

// refresh the cart contents and open the cart
// window.CD_REFRESHCART().then(() => window.CD_OPENCART());

document.addEventListener("DOMContentLoaded", function () {
  function publishCartixView() {
    fetch(window.Shopify.routes.root + "cart.js?v=" + Date.now())
      .then((response) => response.json())
      .then((cart) => {
        
        window.dataLayer = window.dataLayer || [];
        
        window.dataLayer.push({
          event: "view_cart",
          cart_total: (cart.total_price / 100), 
          currency: window.Shopify.currency.active || "USD", 
          items: cart.items.map(item => ({
            product_id: item.product_id,
            variant_id: item.variant_id,
            title: item.product_title,
            price: (item.price / 100),
            quantity: item.quantity
          }))
        });
      })
  }

  let isDrawerCurrentlyOpen = false; 

  const observer = new MutationObserver(() => {
    const cartDrawer = document.querySelector(".cd-cart");

    if (cartDrawer) {
      if (cartDrawer.classList.contains("is-open")) {
        
        if (!isDrawerCurrentlyOpen) {
          isDrawerCurrentlyOpen = true;
          
          setTimeout(() => {
            publishCartixView();
          }, 2000);
        }
        
      } else {
        isDrawerCurrentlyOpen = false;
      }
    }
  });

  observer.observe(document.body, {
    attributes: true,
    subtree: true, 
    attributeFilter: ["class"],
  });
});

